module.exports = __webpack_public_path__ + "9f10fe818553b5018159311cbfcc78b6.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./src/font/OpenSans-Regular.woff
 ** module id = 1227
 ** module chunks = 9
 **/